import { Camera, getCameraDevice } from 'react-native-vision-camera';
import { delay } from './async';

export const getSelectedCameraDevice = async (attempt: number = 1) => {
  const devices = Camera.getAvailableCameraDevices();
  const selectedDevice = getCameraDevice(devices, 'back');
  if (selectedDevice) {
    return selectedDevice;
  } else {
    if (attempt > 3) {
      return null;
    }
    await delay(5000);
    return getSelectedCameraDevice(attempt + 1);
  }
};
